export class InaSchoolEnrollmentSelection {
  inaSchoolEnrollment: InaSchoolEnrollment
}

export interface InaSchoolEnrollment {
  InaSchoolEnrollment: InaSchoolEnrollment2
  Sections: Section[]
  Message: Message
}

export interface InaSchoolEnrollment2 {
  Id: number
  StudentId: number
  SchoolEnrollmentId: number
  StatusTypeId: number
  TermDurationId: number
  EnrollmentType: string
  GradeId: number
  Grade: string
  SchoolYearId: number
  SchoolYear: string
  SchoolLookUpId: number
  RegionId: number
  RegionName: string
  DistrictId: number
  DistrictName: string
  SchoolId: number
  SchoolName: string
  CreatedBy: string
  CreatedDate: string
  ModifiedBy: any
  ModifiedDate: any
  FollowUpName: any
  FollowUpDate: string
}

export interface Section {
  SectionName: string
  SectionID: number
  Questions: Question[]
}

export interface Question {
  Name: string
  Id: number
  lstQuestionValueDataView: LstQuestionValueDataView[]
}

export interface LstQuestionValueDataView {
  Name: string
  Value: string
  Type: string
  Id: number
}

export interface Message {
  Code: number
  Status: string
  Message: string
}
